module.exports = __webpack_public_path__ + "static/media/imh-mn.82c7ba3e.png";